import Footer from 'components/ModalFaqs/Sections/Footer/styled';

export default Footer;
